import Api from './api';

const createCommentRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/comment', data, {headers: { Authorization: 'Bearer ' + access_token }})
}

const getThreatRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/thread', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query
    })
}

const getAllThreadsRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/threads', {headers: { Authorization: 'Bearer ' + access_token }})
}



export default { createCommentRequest, getThreatRequest, getAllThreadsRequest }



// WEBPACK FOOTER //
// ./src/api/apiComments.js